class MFilterTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.tabpanels = [];
    this.firstTab = null;
    this.lastTab = null;
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.tabs.forEach((tab) => {
      const panelId = tab.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      this.tabpanels.push(panel);
      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));
    });

    this.firstTab = this.tabs[0];
    this.lastTab = this.tabs[this.tabs.length - 1];

    if (this.firstTab) {
      this.setSelectedTab(this.firstTab);
    }

    this.initSvgs();
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('keydown', this.onKeydown);
      tab.removeEventListener('click', this.onClick);
    });
  }

  setSelectedTab(currentTab) {
    this.tabs.forEach((tab, index) => {
      const panel = this.tabpanels[index];
      const isActive = tab === currentTab;

      if (isActive) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        panel?.classList.remove('is-hidden');
        tab.style.opacity = '1';
        tab.classList.add('is-active');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        panel?.classList.add('is-hidden');
        tab.style.opacity = '0.8';
        tab.classList.remove('is-active');
      }
    });

    const filterValue = (currentTab.dataset.filter || '').toUpperCase().trim();
    this.querySelectorAll('[data-filter-item]').forEach((ul) => {
      const ulFilter = (ul.getAttribute('data-filter-item') || '').toUpperCase().trim();
      if (ulFilter === filterValue) {
        ul.style.display = '';
      } else {
        ul.style.display = 'none';
      }
    });
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }

  onKeydown(event) {
    const currentTab = event.currentTarget;
    let handled = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.moveFocusToPreviousTab(currentTab);
        handled = true;
        break;
      case 'ArrowRight':
        this.moveFocusToNextTab(currentTab);
        handled = true;
        break;
      case 'Home':
        this.moveFocusToTab(this.firstTab);
        handled = true;
        break;
      case 'End':
        this.moveFocusToTab(this.lastTab);
        handled = true;
        break;
      default:
        break;
    }

    if (handled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  moveFocusToTab(tab) {
    if (tab) {
      tab.focus();
    }
  }

  moveFocusToNextTab(currentTab) {
    if (!currentTab) return;
    if (currentTab === this.lastTab) {
      this.moveFocusToTab(this.firstTab);
    } else {
      const index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index + 1]);
    }
  }

  moveFocusToPreviousTab(currentTab) {
    if (!currentTab) return;
    if (currentTab === this.firstTab) {
      this.moveFocusToTab(this.lastTab);
    } else {
      const index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index - 1]);
    }
  }

  initSvgs() {
    this.querySelectorAll('svg').forEach((svg) => {
      const wrapper = document.createElement('span');
      wrapper.attachShadow({ mode: 'open' }).appendChild(svg.cloneNode(true));
      wrapper.classList.add('flex');
      svg.replaceWith(wrapper);
    });
  }
}

customElements.define('m-filter-tabs', MFilterTabs);
